<template>
  <header class="c-header">
    <div class="c-header__left">
      <div class="c-header__language c-header__icon hide-on-pad">
        <Icon type="language" @clickevent="handleIconClick('language')"></Icon>
        <div class="lang-overlay" :class="{ active: showLangList }" @click="showLangList=false"></div>
        <div class="lang-list" :class="{ show: showLangList }">
          <div 
            class="lang-item" 
            :class="{ active: $i18n.locale==item.code }" 
            v-for="(item,index) in getlangList" 
            :key="'lang_item_'+index"
            @click="handleChangeLang(item.code)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div class="c-header__menu c-header__icon show-on-pad">
        <Icon type="menu" @clickevent="handleIconClick('menu')"></Icon>
      </div>
      <div class="c-header__search c-header__icon show-on-pad">
        <Icon type="search" @clickevent="handleIconClick('search')"></Icon>
      </div>
    </div>
    <div class="c-header__center show-on-pad">
      <router-link :to="{ name: 'Home' }"><img :src="material.logo" alt="logo"></router-link>
    </div>
    <div class="c-header__right">
      <div class="logout hide-on-pad" @click="logout" v-if="userInfo">{{userInfo.user.name}} {{$t('header.logout')}}</div>
      <div class="c-header__search c-header__icon hide-on-pad">
        <Icon type="search" @clickevent="handleIconClick('search')"></Icon>
      </div>
      <div class="c-header__notifications c-header__icon hide-on-pad">
        <Icon type="notification" @clickevent="handleIconClick('notification')"></Icon>
      </div>
      <div class="c-header__account c-header__icon">
        <Icon type="account" @clickevent="handleIconClick('account')"></Icon>
      </div>
      <div class="c-header__favorite c-header__icon hide-on-pad">
        <Icon type="favorite" @clickevent="handleIconClick('favorite')"></Icon>
      </div>
      <div class="c-header__cart c-header__icon">
        <Icon type="cart" @clickevent="handleIconClick('cart')"></Icon>
        <div class="cart__count pos-center" @click="handleIconClick('cart')" v-if="userInfo">{{ number }}</div>
      </div>
    </div>
  </header>
</template>

<script>
import logo from './images/LOGO-01.png'
import { get,del } from "../../utils/localStorage";
import { mapMutations,mapState } from "vuex";
import { getSystemSetup } from '@/api/index'

export default {
  data() {
    return {
      material: { logo },
      username: '',
      showLangList: false,
      lanlist: []
    };
  },
  created() {
    // const userInfo = get('userInfo');
    // console.log('userInfo',userInfo);
    // if(userInfo) {
    //   const { user } = userInfo;
    //   this.username = user.name;
    // }
    getSystemSetup({
      type: 2,
      name: 'lan'
    }).then(res=> {
      console.log('***** getSystemSetup *****');
      console.log(res);
      const lanlistArr = res.data[0];
      this.lanlist = Object.keys(lanlistArr).map(item => lanlistArr[item]);
      
    })
  },
  mounted() {

  },
  computed: {
    ...mapState(['userInfo']),
    number() {
      const cartNumber = this.userInfo.shopcar;
      if(cartNumber  < 10){
        return `+${cartNumber}`
      }
      return cartNumber;
    },
    getlangList() {
      console.log(Object.values(this.$i18n.messages));
      const list = Object.values(this.$i18n.messages).map(item => {
        return { title:item.locale_title, code:item.locale_code };
      });
      const formatList = list.filter(item => {
        console.log(item.locale_code);
        return this.lanlist.includes(item.code);
      });

      return formatList;
    }
  },
  methods: {
    ...mapMutations(['TOGGLE_MENU']),
    handleIconClick(type) {
      switch(type) {
        case 'menu':
          this.TOGGLE_MENU();
          break;
        case 'notification':
          this.$router.push({ name: 'newsCenter' });
          break;
        case 'account':
          this.$router.push({ name: 'userCenter' });
          break;
        case 'favorite':
          this.$router.push({ name: 'favorite' });
          break;
        case 'cart':
          this.$router.push({ name: 'cart' });
          break;
        case 'search':
          this.$router.push({ name: 'search' });
          break;
        case 'language':
          this.showLangList = !this.showLangList;
          break;
        default:
          alert(type);
          break;
      }
    },
    logout(){
      del('token');
      del('userInfo');
      this.$store.commit('CLEAN_USER_INFO');
      this.$router.push({ name: 'register', query: { type: 'login' } });
    },
    handleChangeLang(code) {
      this.showLangList = false;
      localStorage.setItem('language',code);
      return history.go(0);
    }
  },
  components: {
    
  },
};
</script>

<style scoped lang='less'>
.c-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 165px;
  width: 100%;
  height: 46px;
  background: transparent
    linear-gradient(180deg, #af4d96 0%, #c7687e 100%, #f39b51 100%) 0% 0%
    no-repeat padding-box;
  opacity: 1;
  width: 100%;
  box-shadow: 0 3px 5px 2px rgba(0,0,0,.2);
  & /deep/ svg {
      fill: white;
  }
  div {
    flex: 1;
  }
  @media (max-width: 992px) {
    padding: 0 16px;
    background: white;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    & /deep/ svg {
      fill: black;
    }
  }

  .c-header__icon {
    margin: 0 5px;
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: relative;
  }

  .c-header__left {
    display: flex;
    max-width: 100px;
    // .c-header__language {
    //   background: url("./images/language-24px@2x.png") no-repeat;
    //   background-size: contain;
    //   background-position: center center;
    // }
  }

  .c-header__center {
    img {
      width: 100px;
      display: block;
      margin: auto;
    }
  }

  .c-header__right {
    display: flex;
    max-width: 100px;
    position: relative;
    // .c-header__search {
    //   background: url("./images/zoom_out-24px@2x.png") no-repeat;
    //   background-size: contain;
    //   background-position: center center;
    // }

    // .c-header__notifications {
    //   background: url("./images/notifications-24px@2x.png") no-repeat;
    //   background-size: contain;
    //   background-position: center center;
    // }

    // .c-header__account {
    //   background: url("./images/account_circle-24px@2x.png") no-repeat;
    //   background-size: contain;
    //   background-position: center center;
    // }

    // .c-header__favorite {
    //   background: url("./images/favorite_border-24px@2x.png") no-repeat;
    //   background-size: contain;
    //   background-position: center center;
    // }

    .c-header__cart {
      position: relative;
      // background: url("./images/local_grocery_store-24px@2x.png") no-repeat;
      // background-size: contain;
      // background-position: center center;

      .cart__count {
        position: absolute;
        transform: scale(0.6);
        top: 0px;
        left: 6px;
        width: 30px;
        height: 30px;
        background: var(--color-red);
        border-radius: 50%;
        text-align: left;
        letter-spacing: 0px;
        color: #ffffff;
        opacity: 1;
      }
    }
  }
  .logout {
    position: absolute;
    width: 180px;
    left: 0;
    transform: translate(-102%,3px);
    text-align: right;
    color: white;
    cursor: pointer;
  }
  .lang-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
    display: none;
    &.active {
      display: block;
    }
  }
  .lang-list {
    position: absolute;
    top: 28px;
    background: white;
    border-radius: 5px;
    box-shadow: 2px 2px 5px 2px rgba(0,0,0,.2);
    z-index: 10;
    display: none;
    &.show {
      display: block;
    }
    .lang-item {
      // margin-bottom: 15px;
      padding: 15px 30px 0 30px;
      &:nth-last-child(1) {
        padding-bottom: 15px;
      }
      &:hover,&.active {
        color: orange;
      }
    }
  }
}
</style>
